import { Card } from "@blueprintjs/core";
import { FGMaskInput, MaskOptions } from "nsitools-react";
import * as React from "react";
import styled from "styled-components";

const StyledCard = styled(Card)`
  position: relative;
  flex: 1;
  padding-top: 2rem;
`;

const LabelContainer = styled.div`
  position: absolute;
  top: 15px;
  left: 15px;
  font-weight: bold;
`;

export interface ICardReadOnlyMaskInputProps {
  label: string;
  name: string;
  cleaveOptions?: MaskOptions;
}

export const CardReadOnlyMaskInput: React.FunctionComponent<
  ICardReadOnlyMaskInputProps
> = ({ label, name, cleaveOptions }) => {
  return (
    <StyledCard>
      <LabelContainer>{label}</LabelContainer>
      <FGMaskInput cleaveOptions={cleaveOptions} name={name} noLabel />
    </StyledCard>
  );
};

export default CardReadOnlyMaskInput;
